module.exports = __webpack_public_path__ + "img/gobernanza.6562e90b.svg";